import { TableColumn } from "../table/TableColumn";
import { COLUMN_NAME, COLUMN_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_SERIAL_ADDRESS, COLUMN_SITE, COLUMN_DEVICE, COLUMN_PROFILE, COLUMN_QUEUE, COLUMN_MUSTERING_POINT, COLUMN_USER_CHECK, COLUMN_VERSION } from '../../constants/column-types'; //, COLUMN_VERSION
import { ColumnFormattingClasses } from "./constants/ColumnFormattingClasses";

const BiometricColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortDirection: "asc",
        sortByName: "baName",
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Address",
        accessor: "baAddress",
        id: 1,
        isNumeric: true,
        active: true,
        translationKey: "address",
        columnId: COLUMN_ADDRESS
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        sortByName: "baIp",
        sortDirection: "asc",
        id: 2,
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS
    },
    {
        heading: "Serial Number",
        accessor: "serialAddress",
        sortByName: "baSerial",
        sortDirection: "asc",
        id: 3,
        isNumeric: true,
        active: true,
        translationKey: "serialNumber",
        columnId: COLUMN_SERIAL_ADDRESS
    },
    {
        heading: "Version",
        accessor: "version",
        id: 4,
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "baVersion",
        active: false,
        translationKey: "version",
        columnId: COLUMN_VERSION
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        active: false,
        sortDirection: "asc",
        searchOnName: "site.id",
        lookupName: "site.siteName",
        sortByName: "deviceImprox.site.siteName",
        translationKey: "site",
        columnId: COLUMN_SITE
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 6,
        active: false,
        sortDirection: "asc",
        sortByName: "deviceImprox.devName",
        translationKey: "device",
        columnId: COLUMN_DEVICE
    },
    {
        heading: "Preset",
        accessor: "preset",
        id: 7,
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "bioProfile.trnName",
        active: false,
        translationKey: "preset",
        columnId: COLUMN_PROFILE
    },
    {
        heading: "Users (Reader/DB)",
        accessor: "templatesReaderVsDB",
        id: 8,
        isNumeric: false,
        active: true,
        translationKey: "usersReaderVsDB",
        valueFormatting: (value) => {
            if (!value) {
                return '';
            }
            const splitValues = value.split('/');
            const splitActualUsers = splitValues[0];
            const splitUsersExpected = splitValues[1];

            return (splitUsersExpected !== splitActualUsers) ? ColumnFormattingClasses.categoryRed : '';
        },
        columnId: COLUMN_USER_CHECK
    },
    {
        heading: "Queue",
        accessor: "queue",
        isNumeric: true,
        id: 9,
        active: true,
        translationKey: "queue",
        columnId: COLUMN_QUEUE,
    },
    {
        heading: "Mustering Point",
        accessor: "musteringPointLabel",
        isNumeric: false,
        id: 10,
        active: true,
        translationKey: "musteringPoint",
        columnId: COLUMN_MUSTERING_POINT
    }
];

export default BiometricColumns;
